import * as z from "zod"

export const AccountFlagModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  flag_name: z.string(),
  account_id: z.number().int(),
})
